import { AnalyticsStore } from 'bernie-plugin-mobx';
import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';
import analyticsUtil from '../util/analytics-util';

import { pageNames } from '../data/page-names';

export class CommercialTermsController implements Controller {
  public pageId = pageNames.commercialTerms;
  public path = '/:localeName?/commercial-terms';
  public routeName = 'commercialTerms';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "commercial-terms-page" */ '../views/commercial-terms-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const stores = options.stores;
    const { request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const context = request.context;

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve({});
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    const pageData = {
      title: 'Expedia Affiliate Program Commercial Terms',
    };

    return Promise.resolve(pageData) as Promise<PageData>;
  }
}
